import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'
import Patient from './patient.service'
import util from '../util/util'
const patientService = new Patient()

const service = new ApolloClientService()

export default class Device {
  getAllDevices = (arg) => {
    return new Promise((resolve, reject) => {
      service
        .getAllDevices(arg)
        .then((data) => {
          // if (data.status == constants.MESSAGE.SUCCESS) {
          // resolve({ ...data, filters });

          resolve(data)
          // } else {
          //   data.error = true;
          //   reject(data);
          // }
        })
        .catch((err) => console.log(err))
    })
  }

  updateDeviceSchedule = (input) => {
    return new Promise((resolve, reject) => {
      input.patient = this.getFormatedPatient(input.patient)
      input.devices = patientService.getFormatedDev(input.devices)

      service.updateDeviceSchedule(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }
  setUserDeviceToken= (input) => {
    return new Promise((resolve, reject) => {
      service.setUserDeviceToken(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }
  getFullfillments = (input) => {
    return new Promise((resolve, reject) => {
      service.getFullfillments(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }

  getFullfillmentsCount = (input) => {
    return new Promise((resolve, reject) => {
      service.getFullfillmentsCount(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }

  getFullfillmentViewDevices = (input) => {
    return new Promise((resolve, reject) => {
      service.getFullfillmentViewDevices(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }

  updateDeviceOrder = (input) => {
    return new Promise((resolve, reject) => {
      service.updateDeviceOrder(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }
  markAsShipped = (input) => {
    return new Promise((resolve, reject) => {
      service.markAsShipped(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }
    markAsDeleted = (input) => {
    return new Promise((resolve, reject) => {
      service.markAsDeleted(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }
  updateTrackingLink = (input) => {
    return new Promise((resolve, reject) => {
      service.updateTrackingLink(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }
  updateGatewayId = (input) => {
    return new Promise((resolve, reject) => {
      service.updateGatewayId(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }

  updateTracPatchFulfillment = (input) => {
    return new Promise((resolve, reject) => {
      service.updateTracPatchFulfillment(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }
  updateAddress = (input) => {
    return new Promise((resolve, reject) => {
      service.updateAddress(input).then((data) => {
        if (data.status == constants.MESSAGE.SUCCESS) {
          resolve(data)
        } else {
          data.error = true
          reject(data)
        }
      })
    })
  }
  getFormatedPatient = (e) => {
    try{
      if (e?.lastdigitsofphone)
        e.lastdigitsofphone = util.toNumber(e.lastdigitsofphone)

      delete e?.__typename
      delete e?.surgery?.__typename
      delete e?.dailyshift?.__typename
      delete e?.dailyshift?.start?.__typename
      delete e?.dailyshift?.end?.__typename
      console.log(e,'getFormatedPatient')
    }catch(err){
      console.log(err,'getFormatedPatient')
    }
    return e
  }

  getAllCarePlans = (name) => {
    return new Promise((resolve, reject) => {
      service.getAllCarePlans(name).then((data) => {
        console.log(data, '---------------->care plans')
        // if (data.status == constants.MESSAGE.SUCCESS) {
        // resolve({ ...data, filters });

        resolve(data)
        // } else {
        //   data.error = true;
        //   reject(data);
        // }
      })
    })
  }

  getGraphMeasurementData = (patientId, deviceId, count) => {
    return new Promise((resolve, reject) => {
      service
        .getGraphMeasurementData({ patientId, deviceId, count })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
    })
  }

  getRangeMeasurement = (patientid, deviceid, startdate, enddate) => {
    return new Promise((resolve, reject) => {
      service
        .getRangeMeasurement(patientid, deviceid, startdate, enddate)
        .then((data) => {
          console.log('deviceschedule', data)
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  assignDevice = (deviceList, device) => {
    var dev = JSON.parse(JSON.stringify(device))

    if (deviceList && deviceList.length == 0) deviceList = [dev]
    else deviceList.push(dev)
    console.log(deviceList, 'sdfffffffff ', deviceList.length == 0)
    return deviceList
  }

  changeSchedule = (deviceList, index, device) => {
    var dev = JSON.parse(JSON.stringify(device))
    if (deviceList && deviceList.length == 0) deviceList = [device]
    else deviceList[index] = device

    return deviceList
  }

  removeDevice = (id, deviceList) => {
    var devices = JSON.parse(JSON.stringify(deviceList))
    _.remove(devices, { _id: id })
    return devices
  }

  getDeviceSchedule = (patientid) => {
    return new Promise((resolve, reject) => {
      service
        .getDeviceSchedule(patientid)
        .then((data) => {
          console.log('deviceschedule', data)
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
}
